export default "__VITE_ASSET__C2d5u_5C__"